import { useState } from 'react'

// MUI
import { PictureAsPdf, Image, InsertDriveFile } from '@mui/icons-material'

// Types
import { TUploadFileObject } from 'common/types'

// Styles
import styles from './AttachmentPreview.module.scss'

export const useAttachmentPreviewLogic = () => {
  const [previewModalOpen, setPreviewModalOpen] = useState(false)
  const [selectedAttachment, setSelectedAttachment] =
    useState<TUploadFileObject | null>(null)
  const [selectedIndex, setSelectedIndex] = useState<number>(-1)

  const getFileIcon = (filename: string, mimetype: string) => {
    const extension = filename.split('.').pop()?.toLowerCase()

    if (
      mimetype.startsWith('image/') ||
      ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension || '')
    ) {
      return <Image className={`${styles.fileIcon} ${styles.imageIcon}`} />
    }

    if (extension === 'pdf' || mimetype === 'application/pdf') {
      return <PictureAsPdf className={`${styles.fileIcon} ${styles.pdfIcon}`} />
    }

    return (
      <InsertDriveFile className={`${styles.fileIcon} ${styles.genericIcon}`} />
    )
  }

  const handlePreviewClick = (attachment: TUploadFileObject, index: number) => {
    setSelectedAttachment(attachment)
    setSelectedIndex(index)
    setPreviewModalOpen(true)
  }

  const handleClosePreview = () => {
    setPreviewModalOpen(false)
    setSelectedAttachment(null)
    setSelectedIndex(-1)
  }

  const isImage = (mimetype: string, filename: string) => {
    const extension = filename.split('.').pop()?.toLowerCase()
    return (
      mimetype.startsWith('image/') ||
      ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension || '')
    )
  }

  return {
    previewModalOpen,
    selectedAttachment,
    selectedIndex,
    handlePreviewClick,
    handleClosePreview,
    getFileIcon,
    isImage,
  }
}
